"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doLogin = exports.SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = void 0;
var _goToPage = require("./goToPage");
var SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_LOGIN_PATH = '/ssoidentity/Login';
var SSO_IDENTITY_AD_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = "".concat(SSO_IDENTITY_LOGIN_PATH, "?ssoLoginType=ActiveDirectory");
var doLogin = function(event) {
    // Ctrl or Cmd key is pressed, redirect to AD login
    if (Boolean(event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.metaKey)) {
        (0, _goToPage.goToPage)(SSO_IDENTITY_AD_LOGIN_PATH);
        return;
    }
    (0, _goToPage.goToPage)(SSO_IDENTITY_LOGIN_PATH);
};
exports.doLogin = doLogin; //# sourceMappingURL=doLogin.js.map
